"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _Title = _interopRequireDefault(require("../../Title"));
var _FlexTabContainer = _interopRequireDefault(require("../../FlexTabContainer"));
var _utils = require("../../utils");
var _classnames = _interopRequireDefault(require("classnames"));
var _Image = _interopRequireDefault(require("../../Image"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TabPane = _FlexTabContainer["default"].TabPane;
var Article = function Article(props) {
  var source = props.source,
    record = props.record,
    onCallbackHandle = props.onCallbackHandle,
    href = props.href,
    title = props.title,
    article = props.article;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'benefit-tab-flex-default-article',
    onClick: function onClick() {
      if (!href) return;
      window.location.href = href;
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-article-container'
  }, /*#__PURE__*/_react["default"].createElement("section", null, source && ( /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    style: {
      margin: !!source && '0 0 12px 0',
      width: '163px',
      height: '54px'
    },
    source: source
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      wordBreak: 'break-word'
    },
    onClick: function onClick() {
      onCallbackHandle && onCallbackHandle(record);
    }
  }, title && ( /*#__PURE__*/_react["default"].createElement("strong", {
    className: 'wordBreak lineBreak',
    style: {
      fontSize: '18px',
      color: '#FFFFFF',
      lineHeight: '27px',
      padding: '0 0 8px 0'
    }
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'benefit-tab-div-content',
    dangerouslySetInnerHTML: {
      __html: article || ''
    }
  })))));
};
var FlexAccordionCustomer = function FlexAccordionCustomer(props) {
  var className = props.className,
    configuration = props.configuration;
  var childrenNodes = {};
  var getHeightVal = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (getHeightVal) {
      childrenNodes = getHeightVal.current.childNodes;
      //todo optimize
      //12 初始状态下少12 offsetHeight
      //24 距离底部距离
      for (var i = 0; i < childrenNodes.length; i++) {
        getHeightVal.current.childNodes[i].childNodes[0].lastChild.style.height = getHeightVal.current.childNodes[i].childNodes[0].lastChild.childNodes[0].offsetHeight + (i === 0 ? 24 : 0) + 'px';
      }
    }
  }, []);
  var checkTabsStatus = function checkTabsStatus(key) {
    var _childrenNodes = getHeightVal;
    var _loop_1 = function _loop_1(i) {
      //查询到指定要获取高度
      var transformClass = _childrenNodes.current.childNodes[i].childNodes[0];
      if (i == Number(key) - 1) {
        if (transformClass.className.indexOf('am-accordion-item-leave') > -1) {
          setTimeout(function () {
            //24 距离底部距离
            transformClass.lastChild.style.height = transformClass.lastChild.childNodes[0].offsetHeight + 24 + 'px';
          });
          transformClass.className = 'am-accordion-item';
        } else {
          transformClass.lastChild.style.height = '0';
          transformClass.className = 'am-accordion-item-leave';
        }
      } else {
        transformClass.lastChild.style.height = '0';
        transformClass.className = 'am-accordion-item-leave';
      }
    };
    //todo optimize
    for (var i = 0; i < _childrenNodes.current.childNodes.length; i++) {
      _loop_1(i);
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('benefit-tab-flex-default-accordion-customer', className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "demoContainer"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "am-accordion my-accordion"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: getHeightVal
  }, configuration.map(function (item, i) {
    var _a = item,
      tabTitle = _a.tabTitle,
      key = _a.key,
      imageSrc = _a.imageSrc,
      article = _a.article;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: 'am-accordion-tab',
      key: i
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])({
        'am-accordion-item': i == 0,
        'am-accordion-item-leave': i !== 0
      }),
      onClick: function onClick() {
        checkTabsStatus(key);
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "am-accordion-title",
      role: "button",
      "aria-expanded": "false"
    }, /*#__PURE__*/_react["default"].createElement("div", null, tabTitle), /*#__PURE__*/_react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      className: 'design-iconfont d-icon'
    }, /*#__PURE__*/_react["default"].createElement("path", {
      transform: "rotate(-180 12.25 12.25)",
      d: "M12.5 10.8035221L17.6191093 16 19 14.5982389 12.5 8 6 14.5982389 7.3808907 16z",
      fillRule: "evenodd"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'am-accordion-container'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "am-accordion-content"
    }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
      width: 327,
      height: 184,
      style: {
        margin: '0 auto'
      },
      source: imageSrc
    }), /*#__PURE__*/_react["default"].createElement(Article, {
      article: article
    })))));
  }))))));
};
function BenefitTab(props) {
  var configuration = props.configuration,
    flexTitle = props.flexTitle,
    style = props.style,
    onTabClick = props.onTabClick;
  //判断是否使用的样式类型 -pc or mobile
  var _a = (0, _react.useState)(true),
    currentClass = _a[0],
    setCurrentClass = _a[1];
  (0, _react.useEffect)(function () {
    (0, _utils.windowAddEventListener)(setCurrentClass);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-benefit-tab',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-benefit-tab-children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle
  }), currentClass ? ( /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      padding: '0 24px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_FlexTabContainer["default"], null, configuration ? configuration.map(function (item, index) {
    var _a = item || {},
      imageSrc = _a.imageSrc,
      article = _a.article,
      key = _a.key,
      tabTitle = _a.tabTitle,
      imageAlt = _a.imageAlt;
    var _b = (0, _utils.fomateFileData)(imageSrc),
      url = _b.url,
      _c = _b.alt,
      alt = _c === void 0 ? '' : _c;
    return /*#__PURE__*/_react["default"].createElement(TabPane, {
      onTabClick: onTabClick,
      key: index,
      record: item,
      tabIndex: key,
      title: tabTitle
    }, /*#__PURE__*/_react["default"].createElement("section", {
      className: 'ant-tabs-content-holder__section',
      style: {
        marginTop: '24px'
      }
    }, /*#__PURE__*/_react["default"].createElement("section", {
      className: 'flex-default-benefit-tab-children__section flex-default-benefit-tab-children__section--reversal'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-default-benefit-tab-children__section__left'
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: url,
      alt: alt
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-default-benefit-tab-children__section__left__article',
      dangerouslySetInnerHTML: {
        __html: imageAlt || ''
      }
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-default-benefit-tab-children__section__right"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-default-benefit-tab-children__section__right--href__container'
    }, /*#__PURE__*/_react["default"].createElement("article", {
      dangerouslySetInnerHTML: {
        __html: article
      }
    }))))));
  }) : null))) : ( /*#__PURE__*/_react["default"].createElement(FlexAccordionCustomer, {
    configuration: configuration
  }))));
}
BenefitTab.displayName = 'TCIBenefitTab';
// @ts-ignore
var _default = exports["default"] = BenefitTab;